module.exports = __webpack_public_path__ + "static/media/lamp-ico.9ece66c5.svg";